<template>
	<div>
		<div class="view-framework-sidebar">
			<div class="sidebar-body">
				<div class="sidebar-nav">
					<ul class="sidebar-items">
						<li  :class="{current:tabStr === '/user'}">
							<router-link :to="{path:'/user'}">
									<i class="iconfont icon-zhanghu"></i>
									我的资料
							</router-link>
						</li>
						<li class="" :class="{current:tabStr === '/withdraw'}">
							<router-link :to="{path:'/withdraw'}">
									<i class="iconfont icon-tixian"></i>
									我要提现
							</router-link>
						</li>
						<li class="" :class="{current:tabStr === '/withdrawAccount'}">
							<router-link :to="{path:'/withdrawAccount'}">
									<i class="iconfont icon-tixianzhanghu"></i>
									提现账户
							</router-link>
						</li>
					</ul>
				</div>
				<div class="sidebar-nav">
					<ul class="sidebar-items">
						<li class="" :class="{current:tabStr === '/order'||tabStr === '/orderDetail'}">
							<router-link :to="{path:'/order'}">
									<i class="iconfont icon-wodedingdan"></i>
									我的订单
							</router-link>
						</li>
						<li class="" :class="{current:tabStr === '/withdrawList'}">
							<router-link :to="{path:'/withdrawList'}">
									<i class="iconfont icon-tixianjilu"></i>
									提现记录
							</router-link>
						</li>
						<li class="" :class="{current:tabStr === '/face_detail'}">
							<router-link :to="{path:'/face_detail'}">
									<i class="iconfont icon-zijinmingxi"></i>
									资金明细
							</router-link>
						</li>
					</ul>
				</div>
				<div class="sidebar-nav">
					<ul class="sidebar-items">
						<li class="" :class="{current:tabStr === '/statistics'}">
							<router-link :to="{path:'/statistics'}">
									<i class="iconfont icon-tongji"></i>
									销卡统计
							</router-link>
						</li>
						<li class="" :class="{current:tabStr === '/setting'||tabStr === '/bindPhone' || tabStr === '/passWord' || tabStr === '/updatePhone'}">
							<router-link :to="{path:'/setting'}">
									<i class="iconfont icon-jibenziliao"></i>
									资料管理
							</router-link>
						</li>
					</ul>
				</div>
				<div class="sidebar-call">
					<h5>客服电话</h5>
					<p>{{mobile}}</p>
					<small>（08:30-23:00）</small>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				tabStr:"",
				mobile:""
			}
		},
		created(){
			this.tabStr =  window.location.hash.replace(/[#]/g, '')
			this.mobile = JSON.parse(localStorage.getItem('datum')).mobile
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/user/index.vue